webpackJsonp([8],{

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryDraftView_vue__ = __webpack_require__(1232);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e984214_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryDraftView_vue__ = __webpack_require__(1305);
function injectStyle (ssrContext) {
  __webpack_require__(1298)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e984214"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecretaryDraftView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e984214_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecretaryDraftView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormAlert',
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'warning'
    },
    // For alerts that are created already holding their message (rendered with v-if), where the
    // `message` watcher never fires: scroll to it once when it mounts.
    scrollOnMount: {
      type: Boolean,
      default: false
    },
    // No outer padding — for alerts positioned by the caller (e.g. overlaid on a table row)
    flush: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dismissed: false
    };
  },
  mounted: function mounted() {
    if (this.scrollOnMount && this.message) this.scrollToAlert();
  },
  watch: {
    message: function message(val) {
      this.dismissed = false;
      if (val) this.scrollToAlert();
    }
  },
  methods: {
    // Click on the message closes it. Hidden locally, and `dismiss` lets a caller that keeps the
    // message in its own state clear it too (so the same text can be shown again next time).
    dismiss: function dismiss() {
      this.dismissed = true;
      this.$emit('dismiss');
    },
    scrollToAlert: function scrollToAlert() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$el) {
          _this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__ = __webpack_require__(1131);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fcd5d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fcd5d34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("416c99d6", content, true, {});

/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".form-alert[data-v-3fcd5d34]{padding:.75rem 0}.form-alert--flush[data-v-3fcd5d34]{padding:0}.form-alert__body[data-v-3fcd5d34]{cursor:pointer;white-space:pre-line;text-align:left}.fade-enter-active[data-v-3fcd5d34]{transition:opacity .3s}.fade-leave-active[data-v-3fcd5d34]{transition:opacity .15s}.fade-enter[data-v-3fcd5d34],.fade-leave-to[data-v-3fcd5d34]{opacity:0}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormAlert.vue"],"names":[],"mappings":"AACA,6BACE,gBAAmB,CACpB,AACD,oCACE,SAAW,CACZ,AACD,mCACE,eAAgB,AAMhB,qBAAsB,AACtB,eAAiB,CANlB,AAQD,oCACE,sBAAyB,CAC1B,AACD,oCACE,uBAA0B,CAC3B,AACD,6DAEE,SAAW,CACZ","file":"FormAlert.vue","sourcesContent":["\n.form-alert[data-v-3fcd5d34] {\n  padding: 0.75rem 0;\n}\n.form-alert--flush[data-v-3fcd5d34] {\n  padding: 0;\n}\n.form-alert__body[data-v-3fcd5d34] {\n  cursor: pointer;\n}\n\n/* Keep newlines from multi-line messages (e.g. a list of blocked competitors)\n   so they render one per line instead of a run-on sentence. */\n.form-alert__body[data-v-3fcd5d34] {\n  white-space: pre-line;\n  text-align: left;\n}\n.fade-enter-active[data-v-3fcd5d34] {\n  transition: opacity 0.3s;\n}\n.fade-leave-active[data-v-3fcd5d34] {\n  transition: opacity 0.15s;\n}\n.fade-enter[data-v-3fcd5d34],\n.fade-leave-to[data-v-3fcd5d34] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message && !_vm.dismissed)?_c('div',{staticClass:"form-alert",class:{ 'form-alert--flush': _vm.flush },attrs:{"role":"alert"}},[_c('div',{staticClass:"form-alert__body alert-pop",class:("alert alert-" + _vm.type + " mb-0"),attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFormAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useFormAlert() {
  var message = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var type = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('warning');
  var timer = null;

  function apply(msg, autoDismiss) {
    message.value = msg;

    if (autoDismiss) {
      timer = setTimeout(function () {
        message.value = null;
      }, 5000);
    }
  }

  function show(msg, alertType, autoDismiss) {
    clearTimeout(timer);
    type.value = alertType;

    if (message.value != null) {
      message.value = null;
      Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])(function () {
        return apply(msg, autoDismiss);
      });
    } else {
      apply(msg, autoDismiss);
    }
  }

  function showError(msg) {
    show(msg, 'warning', true);
  }

  function showSuccess(msg) {
    show(msg != null ? msg : 'Success', 'success', true);
  }

  function showPersistentError(msg) {
    show(msg, 'warning', false);
  }

  function clear() {
    clearTimeout(timer);
    message.value = null;
  }

  return {
    message: message,
    type: type,
    showError: showError,
    showSuccess: showSuccess,
    showPersistentError: showPersistentError,
    clear: clear
  };
}

/***/ }),

/***/ 1138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormAlert__ = __webpack_require__(1127);
//
//
//
//
//
//
 // A message overlaid on the bottom of the row above (its parent must be a zero-height, relatively
// positioned anchor — GridTable's `before-row` slot is one), so it appears right over the row it is
// about without pushing the table apart. `alertKey` changes for every new message, even with the
// same text, so it re-appears. Click dismisses it.

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RowAlert',
  components: {
    FormAlert: __WEBPACK_IMPORTED_MODULE_0__components_FormAlert__["a" /* default */]
  },
  props: {
    message: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'success'
    },
    alertKey: {
      type: [Number, String],
      default: 0
    },
    // The alert lives inside a (position: relative) table row instead of a zero-height anchor above
    // it: place its bottom edge on that row's top edge.
    aboveRow: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 1140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  eventTypes: function eventTypes() {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/event-types');
  },
  create: function create(draftId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/events"), data, {
      silent: true
    });
  },
  getEdit: function getEdit(draftId, eventId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/events/").concat(eventId, "/edit"));
  },
  update: function update(draftId, eventId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put("/v2/drafts/".concat(draftId, "/events/").concat(eventId), data, {
      silent: true
    });
  },
  // localSuccess: the caller shows the result itself (next to the event); without it the http client
  // would also push it to the page-top alert and scroll the page up.
  destroy: function destroy(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/events/".concat(id), {
      silent: true,
      localSuccess: true
    });
  },
  reorder: function reorder(draftId, ids) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/drafts/".concat(draftId, "/events/reorder"), {
      ids: ids
    }, {
      silent: true,
      localSuccess: true
    });
  },
  nominationsDashboard: function nominationsDashboard(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/drafts/".concat(draftId, "/events/nominations-dashboard"));
  },
  lock: function lock(id, isLocked) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].patch("/v2/events/".concat(id, "/lock"), {
      is_locked: isLocked
    }, {
      silent: true,
      localSuccess: true
    });
  },
  deleteSponsorLogo: function deleteSponsorLogo(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/events/".concat(id, "/sponsor-logo"), {
      silent: true
    });
  },
  split: function split(id) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/events/".concat(id, "/split"), {}, {
      silent: true,
      localSuccess: true
    });
  }
});

/***/ }),

/***/ 1142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RowAlert_vue__ = __webpack_require__(1138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f28bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RowAlert_vue__ = __webpack_require__(1153);
function injectStyle (ssrContext) {
  __webpack_require__(1151)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69f28bea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RowAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f28bea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RowAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FRadioGroup',
  props: {
    name: {
      type: String,
      required: true
    },
    label: String,
    value: {
      default: null
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: Boolean,
    required: Boolean,
    inline: Boolean,
    error: {
      type: String,
      default: null
    }
  }
});

/***/ }),

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRowAlert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
 // The result of an action on one table row, shown right above that row (see RowAlert.vue) instead
// of at the top of the page. Auto-dismisses after 5s unless `persistent`; every call gets a new id
// so repeating an action with the same text re-creates the message and is visibly "new".

function useRowAlert() {
  var empty = function empty() {
    return {
      message: null,
      type: 'success',
      rowId: null,
      id: 0
    };
  };

  var alert = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(empty());
  var seq = 0;
  var timer = null;

  function clear() {
    clearTimeout(timer);
    alert.value = empty();
  }

  function show(message, type, rowId) {
    var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref$persistent = _ref.persistent,
        persistent = _ref$persistent === void 0 ? false : _ref$persistent;

    clearTimeout(timer);
    alert.value = {
      message: message,
      type: type,
      rowId: rowId,
      id: ++seq
    };
    if (!persistent) timer = setTimeout(clear, 5000);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
    return clearTimeout(timer);
  });
  return {
    alert: alert,
    show: show,
    clear: clear,
    showSuccess: function showSuccess(message, rowId) {
      return show(message, 'success', rowId);
    },
    showError: function showError(message, rowId, options) {
      return show(message, 'warning', rowId, options);
    }
  };
}

/***/ }),

/***/ 1151:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1152);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("35f89dda", content, true, {});

/***/ }),

/***/ 1152:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".row-alert[data-v-69f28bea]{position:absolute;right:0;bottom:0;left:0;height:0}.row-alert--above-row[data-v-69f28bea]{bottom:100%}.row-alert[data-v-69f28bea] .form-alert{position:absolute;right:8px;bottom:6px;left:8px}.row-alert[data-v-69f28bea] .alert{box-shadow:0 2px 8px rgba(0,0,0,.2)}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/RowAlert.vue"],"names":[],"mappings":"AACA,4BACE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,OAAQ,AACR,QAAU,CACX,AACD,uCACE,WAAa,CACd,AAID,wCACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,QAAU,CACX,AACD,mCACE,mCAAyC,CAC1C","file":"RowAlert.vue","sourcesContent":["\n.row-alert[data-v-69f28bea] {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 0;\n}\n.row-alert--above-row[data-v-69f28bea] {\n  bottom: 100%;\n}\n\n/* Absolute as well: while a new message replaces the old one (which is still fading out) the two\n   overlap in the same spot instead of stacking and shoving each other upwards. */\n.row-alert[data-v-69f28bea] .form-alert {\n  position: absolute;\n  right: 8px;\n  bottom: 6px;\n  left: 8px;\n}\n.row-alert[data-v-69f28bea] .alert {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"row-alert",class:{ 'row-alert--above-row': _vm.aboveRow }},[_c('form-alert',{key:_vm.alertKey,attrs:{"message":_vm.message,"type":_vm.type,"scroll-on-mount":"","flush":""},on:{"dismiss":function($event){return _vm.$emit('dismiss')}}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildEventGroups;
/* harmony export (immutable) */ __webpack_exports__["c"] = flattenEventGroups;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildLeafEventGroups;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Groups a draft's flat, ordered event list for the Events table so that related events can
 * only be moved together:
 *   - a combined parent and its children form one unit (children only reorder inside it);
 *   - units tied by brother_id form one group (regular split A+B, combined split A+B, and a
 *     conjunction pair with its final) and are moved as a whole.
 * Units inside a group keep a fixed order (by id: the original/A row is always the lowest id).
 *
 * @param {Array} events flat list, already in display order
 * @returns {Array<{ id: number, units: Array<{ row: Object, children: Object[] }> }>}
 */
function buildEventGroups(events) {
  var position = new Map(events.map(function (event, index) {
    return [event.id, index];
  }));
  var ids = new Set(events.map(function (event) {
    return event.id;
  }));
  var childrenByParent = new Map();
  var roots = [];
  events.forEach(function (event) {
    if (event.parent_id != null && ids.has(event.parent_id)) {
      if (!childrenByParent.has(event.parent_id)) childrenByParent.set(event.parent_id, []);
      childrenByParent.get(event.parent_id).push(event);
    } else {
      roots.push(event);
    }
  });
  var rootById = new Map(roots.map(function (root) {
    return [root.id, root];
  }));
  var family = new Map(roots.map(function (root) {
    return [root.id, root.id];
  }));

  function find(id) {
    while (family.get(id) !== id) {
      id = family.get(id);
    }

    return id;
  }

  roots.forEach(function (root) {
    if (root.brother_id != null && rootById.has(root.brother_id)) {
      family.set(find(root.id), find(root.brother_id));
    }
  });
  var unitsByFamily = new Map();
  roots.forEach(function (root) {
    var key = find(root.id);
    if (!unitsByFamily.has(key)) unitsByFamily.set(key, []);
    unitsByFamily.get(key).push({
      row: root,
      children: childrenByParent.get(root.id) || []
    });
  });
  return _toConsumableArray(unitsByFamily.values()).map(function (units) {
    units.sort(function (a, b) {
      return a.row.id - b.row.id;
    });
    return {
      id: units[0].row.id,
      units: units,
      position: Math.min.apply(Math, _toConsumableArray(units.map(function (unit) {
        return position.get(unit.row.id);
      })))
    };
  }).sort(function (a, b) {
    return a.position - b.position;
  }).map(function (_ref) {
    var id = _ref.id,
        units = _ref.units;
    return {
      id: id,
      units: units
    };
  });
}
function flattenEventGroups(groups) {
  return groups.flatMap(function (group) {
    return group.units.flatMap(function (unit) {
      return [unit.row.id].concat(_toConsumableArray(unit.children.map(function (child) {
        return child.id;
      })));
    });
  });
}
/**
 * Same grouping for a list that has no parent rows (only leaf events): a unit is the set of
 * rows sharing a parent_id (or a lone event), and units are tied into one group through
 * brother_id (own, or the parent's `parent_brother_id`) — a regular split pair, a combined
 * split A+B, or a conjunction pair with its final.
 *
 * @param {Array} events flat list, already in display order
 * @returns {Array<{ id: number, rows: Object[] }>} rows are ordered unit by unit (lowest id first)
 */

function buildLeafEventGroups(events) {
  var unitKey = function unitKey(event) {
    return event.parent_id != null ? event.parent_id : event.id;
  };

  var brotherKey = function brotherKey(event) {
    return event.parent_id != null ? event.parent_brother_id : event.brother_id;
  };

  var family = new Map(events.map(function (event) {
    return [unitKey(event), unitKey(event)];
  }));

  function find(key) {
    while (family.get(key) !== key) {
      key = family.get(key);
    }

    return key;
  }

  events.forEach(function (event) {
    var brother = brotherKey(event);

    if (brother != null && family.has(brother)) {
      family.set(find(unitKey(event)), find(brother));
    }
  });
  var groups = new Map();
  events.forEach(function (event, index) {
    var key = find(unitKey(event));
    if (!groups.has(key)) groups.set(key, {
      rows: [],
      position: index
    });
    groups.get(key).rows.push({
      event: event,
      index: index
    });
  });
  return _toConsumableArray(groups.values()).sort(function (a, b) {
    return a.position - b.position;
  }).map(function (_ref2) {
    var rows = _ref2.rows;
    rows.sort(function (a, b) {
      return unitKey(a.event) - unitKey(b.event) || a.index - b.index;
    });
    return {
      id: rows[0].event.id,
      rows: rows.map(function (row) {
        return row.event;
      })
    };
  });
}

/***/ }),

/***/ 1169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FRadioGroup_vue__ = __webpack_require__(1143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df08032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FRadioGroup_vue__ = __webpack_require__(1170);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FRadioGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4df08032_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FRadioGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.label)),(_vm.required)?_c('span',{staticClass:"text-danger ml-1"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{class:{ 'd-flex flex-wrap': _vm.inline }},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,staticClass:"custom-control custom-radio",class:{ 'mr-4': _vm.inline }},[_c('input',{staticClass:"custom-control-input",attrs:{"id":(_vm.name + "_" + (option.value)),"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":option.value,"checked":_vm.value === option.value},on:{"change":function($event){return _vm.$emit('input', option.value)}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label font-weight-normal",attrs:{"for":(_vm.name + "_" + (option.value))}},[_vm._v(_vm._s(option.label))])])}),0),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"text-danger small mt-1"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDraftEvents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api_events__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }





function useDraftEvents() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onError = _ref.onError,
      onSuccess = _ref.onSuccess;

  var events = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var deleting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var currentDraftId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

  function emitError(msg) {
    if (onError) onError(msg);else __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('http-error', msg);
  }

  function emitSuccess(msg) {
    if (onSuccess) onSuccess(msg);else __WEBPACK_IMPORTED_MODULE_3__store_EventBus__["a" /* default */].$emit('show-success', msg);
  }

  function loadEvents(_x) {
    return _loadEvents.apply(this, arguments);
  }

  function _loadEvents() {
    _loadEvents = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(draftId) {
      var res, data, msg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentDraftId.value = draftId;
              loading.value = true;
              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].events(draftId);

            case 5:
              res = _context.sent;
              events.value = res.data.data;
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              data = _context.t0.response != null ? _context.t0.response.data : null;
              msg = data != null && data.message != null ? data.message : 'Failed to load events.';
              emitError(msg);

            case 14:
              _context.prev = 14;
              loading.value = false;
              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9, 14, 17]]);
    }));
    return _loadEvents.apply(this, arguments);
  }

  function reorderEvents(_x2, _x3) {
    return _reorderEvents.apply(this, arguments);
  }

  function _reorderEvents() {
    _reorderEvents = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(orderedIds, draftId) {
      var id, res, msg, data, _msg;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              id = draftId != null ? draftId : currentDraftId.value;
              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__services_api_events__["a" /* default */].reorder(id, orderedIds);

            case 4:
              res = _context2.sent;
              msg = res.data != null && res.data.message != null ? res.data.message : 'Events order has been saved.';
              emitSuccess(msg);
              return _context2.abrupt("return", true);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](1);
              data = _context2.t0.response != null ? _context2.t0.response.data : null;
              _msg = data != null && data.message != null ? data.message : 'Failed to save order.';
              emitError(_msg);

              if (!(currentDraftId.value != null)) {
                _context2.next = 18;
                break;
              }

              _context2.next = 18;
              return loadEvents(currentDraftId.value);

            case 18:
              return _context2.abrupt("return", false);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 10]]);
    }));
    return _reorderEvents.apply(this, arguments);
  }

  function deleteEvent(_x4) {
    return _deleteEvent.apply(this, arguments);
  }

  function _deleteEvent() {
    _deleteEvent = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(eventId) {
      var res, msg, data, _msg2;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              deleting.value = true;
              _context3.prev = 1;
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_2__services_api_events__["a" /* default */].destroy(eventId);

            case 4:
              res = _context3.sent;
              msg = res.data != null && res.data.message != null ? res.data.message : 'The event has been deleted.';
              _context3.next = 8;
              return loadEvents(currentDraftId.value);

            case 8:
              emitSuccess(msg);
              _context3.next = 16;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);
              data = _context3.t0.response != null ? _context3.t0.response.data : null;
              _msg2 = data != null && data.message != null ? data.message : 'Failed to delete event.';
              emitError(_msg2);

            case 16:
              _context3.prev = 16;
              deleting.value = false;
              return _context3.finish(16);

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 11, 16, 19]]);
    }));
    return _deleteEvent.apply(this, arguments);
  }

  return {
    events: events,
    loading: loading,
    deleting: deleting,
    loadEvents: loadEvents,
    deleteEvent: deleteEvent,
    reorderEvents: reorderEvents
  };
}

/***/ }),

/***/ 1232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__composables_useRowAlert__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_RowAlert__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_EventBus__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__composables_drafts_useDraftView__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__composables_drafts_useDraftEvents__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__composables_drafts_useDraftRules__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_date__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_eventGroups__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_DraftFilterNominations__ = __webpack_require__(1302);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'SecretaryDraftView',
  components: {
    Draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a,
    RowAlert: __WEBPACK_IMPORTED_MODULE_9__components_RowAlert__["a" /* default */],
    TabLayout: __WEBPACK_IMPORTED_MODULE_2__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_3__components_PageHeading__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_4__components_ConfirmModal__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_5__components_FormAlert__["a" /* default */],
    FText: __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FText__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_7__components_FormFields_FSearchSelect__["a" /* default */],
    DraftFilterNominations: __WEBPACK_IMPORTED_MODULE_16__components_DraftFilterNominations__["a" /* default */]
  },
  props: {
    draftId: {
      type: [String, Number],
      required: true
    }
  },
  setup: function setup(props) {
    var _useDraftView = Object(__WEBPACK_IMPORTED_MODULE_11__composables_drafts_useDraftView__["a" /* default */])(),
        draft = _useDraftView.draft,
        loading = _useDraftView.loading,
        loadFailed = _useDraftView.loadFailed,
        loadDraft = _useDraftView.loadDraft; // Results of reorder / delete appear right above the event they were done on (above-row alert in
    // its row); anything not tied to an event goes to the page-top alert as before.


    var _useRowAlert = Object(__WEBPACK_IMPORTED_MODULE_8__composables_useRowAlert__["a" /* default */])(),
        rowAlert = _useRowAlert.alert,
        showRowAlert = _useRowAlert.show,
        clearRowAlert = _useRowAlert.clear;

    var alertRowId = null;

    var _useDraftEvents = Object(__WEBPACK_IMPORTED_MODULE_12__composables_drafts_useDraftEvents__["a" /* default */])({
      onError: function onError(msg) {
        return alertRowId != null ? showRowAlert(msg, 'warning', alertRowId) : __WEBPACK_IMPORTED_MODULE_10__store_EventBus__["a" /* default */].$emit('http-error', msg);
      },
      onSuccess: function onSuccess(msg) {
        return alertRowId != null ? showRowAlert(msg, 'success', alertRowId) : __WEBPACK_IMPORTED_MODULE_10__store_EventBus__["a" /* default */].$emit('show-success', msg);
      }
    }),
        events = _useDraftEvents.events,
        eventsLoading = _useDraftEvents.loading,
        deleting = _useDraftEvents.deleting,
        loadEvents = _useDraftEvents.loadEvents,
        deleteEvent = _useDraftEvents.deleteEvent,
        reorderEvents = _useDraftEvents.reorderEvents;

    var _useDraftRules = Object(__WEBPACK_IMPORTED_MODULE_13__composables_drafts_useDraftRules__["a" /* default */])(),
        rules = _useDraftRules.rules,
        submittingRules = _useDraftRules.submitting,
        rulesAlert = _useDraftRules.alert,
        pinnedEventIds = _useDraftRules.pinnedEventIds,
        initRules = _useDraftRules.initRules,
        saveRules = _useDraftRules.saveRules,
        setExcludeFirstRound = _useDraftRules.setExcludeFirstRound,
        setExcludeTotal = _useDraftRules.setExcludeTotal;

    var eventToDelete = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

    function confirmDelete(event) {
      eventToDelete.value = event;
    }

    function handleDelete() {
      return _handleDelete.apply(this, arguments);
    } // Local mutable copy: Sortable splices the list it is given in place.


    function _handleDelete() {
      _handleDelete = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var id, list, index, neighbour;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (eventToDelete.value) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                id = eventToDelete.value.id;
                eventToDelete.value = null; // The row is gone once the result is shown: anchor on the event that follows it (or precedes it)

                list = events.value;
                index = list.findIndex(function (e) {
                  return e.id === id;
                });
                neighbour = index === -1 ? null : list[index + 1] || list[index - 1];
                alertRowId = neighbour != null ? neighbour.id : null;
                _context2.next = 10;
                return deleteEvent(id);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _handleDelete.apply(this, arguments);
    }

    var eventGroups = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(events, function (list) {
      eventGroups.value = Object(__WEBPACK_IMPORTED_MODULE_15__utils_eventGroups__["b" /* buildLeafEventGroups */])(list);
    }, {
      immediate: true
    }); // Row position at which each group starts, to keep striping continuous across tbody blocks.

    var groupStart = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var starts = {};
      var n = 0;
      eventGroups.value.forEach(function (group) {
        starts[group.id] = n;
        n += group.rows.length;
      });
      return starts;
    }); // 1 when the group starts on an odd row — rendered as a hidden header row (see the template).
    // A `v-for`, not a `v-if`: a false `v-if` leaves an empty comment vnode in vuedraggable's default
    // slot, which shifts every row index it computes by one (drag-and-drop then moves the wrong row
    // and can splice `undefined` into the list).

    function stripeOffset(group) {
      return groupStart.value[group.id] % 2;
    } // Groups may be dropped between each other but never before the header row. (No `draggable`
    // selector on the table: vuedraggable assumes Sortable's indexes include the header slot.)


    function onMoveGroup(evt) {
      return evt.related.tagName === 'TBODY';
    } // Children of one parent (E1/E2, A/B halves) may swap places, but never leave their own unit.


    function hasSiblings(event, group) {
      return event.parent_id != null && group.rows.filter(function (row) {
        return row.parent_id === event.parent_id;
      }).length > 1;
    }

    function onMoveWithinUnit(evt) {
      var related = evt.relatedContext.element;
      return related != null && related.parent_id === evt.draggedContext.element.parent_id;
    }

    function onDragEnd(evt) {
      // The dragged row (a group's first row, or the child row) — set via data-row-id in the template
      var item = evt && evt.item;
      var holder = item && (item.dataset.rowId != null ? item : item.querySelector('[data-row-id]'));
      var movedId = holder ? Number(holder.dataset.rowId) : null;
      alertRowId = Number.isNaN(movedId) ? null : movedId;
      var ordered = eventGroups.value.flatMap(function (group) {
        return group.rows;
      });
      events.value = ordered;
      reorderEvents(ordered.map(function (e) {
        return e.id;
      }));
    }

    function maxHorsesOrSubmissions(event) {
      if (event.requires_horse === false) {
        return event.max_submissions != null ? event.max_submissions : '';
      }

      return event.max_horses === 0 ? '' : event.max_horses;
    }

    function handleSaveRules() {
      return _handleSaveRules.apply(this, arguments);
    }

    function _handleSaveRules() {
      _handleSaveRules = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return saveRules(props.draftId);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _handleSaveRules.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([loadDraft(props.draftId), loadEvents(props.draftId)]);

            case 2:
              if (draft.value) {
                initRules(draft.value, events.value);
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return {
      draft: draft,
      loading: loading,
      loadFailed: loadFailed,
      events: events,
      eventGroups: eventGroups,
      groupStart: groupStart,
      rowAlert: rowAlert,
      clearRowAlert: clearRowAlert,
      stripeOffset: stripeOffset,
      onMoveGroup: onMoveGroup,
      hasSiblings: hasSiblings,
      onMoveWithinUnit: onMoveWithinUnit,
      eventsLoading: eventsLoading,
      deleting: deleting,
      eventToDelete: eventToDelete,
      confirmDelete: confirmDelete,
      handleDelete: handleDelete,
      onDragEnd: onDragEnd,
      maxHorsesOrSubmissions: maxHorsesOrSubmissions,
      pinnedEventIds: pinnedEventIds,
      setExcludeFirstRound: setExcludeFirstRound,
      setExcludeTotal: setExcludeTotal,
      rules: rules,
      submittingRules: submittingRules,
      rulesAlert: rulesAlert,
      handleSaveRules: handleSaveRules,
      formatDate: __WEBPACK_IMPORTED_MODULE_14__utils_date__["a" /* formatDate */]
    };
  }
}));

/***/ }),

/***/ 1233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FRadioGroup__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FSearchSelect__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormAlert__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ConfirmModal__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_drafts_useFilterNominations__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__composables_useFormAlert__ = __webpack_require__(1132);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var FILTER_BY_OPTIONS = [{
  value: 'horse',
  label: 'Horse'
}, {
  value: 'rider',
  label: 'Rider'
}];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'DraftFilterNominations',
  components: {
    FRadioGroup: __WEBPACK_IMPORTED_MODULE_1__components_FormFields_FRadioGroup__["a" /* default */],
    FSearchSelect: __WEBPACK_IMPORTED_MODULE_2__components_FormFields_FSearchSelect__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */],
    FormAlert: __WEBPACK_IMPORTED_MODULE_4__components_FormAlert__["a" /* default */],
    ConfirmModal: __WEBPACK_IMPORTED_MODULE_5__components_ConfirmModal__["a" /* default */]
  },
  props: {
    events: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useFilterNominations = Object(__WEBPACK_IMPORTED_MODULE_6__composables_drafts_useFilterNominations__["a" /* default */])(),
        filterBy = _useFilterNominations.filterBy,
        selectedEventId = _useFilterNominations.selectedEventId,
        selectedTypeId = _useFilterNominations.selectedTypeId,
        statistics = _useFilterNominations.statistics,
        loadingStats = _useFilterNominations.loadingStats,
        scratching = _useFilterNominations.scratching,
        statusOptions = _useFilterNominations.statusOptions,
        loadFilterStatuses = _useFilterNominations.loadFilterStatuses,
        setFilterBy = _useFilterNominations.setFilterBy,
        fetchStatistics = _useFilterNominations.fetchStatistics,
        scratchAll = _useFilterNominations.scratchAll;

    var alert = Object(__WEBPACK_IMPORTED_MODULE_7__composables_useFormAlert__["a" /* default */])();
    var confirmScratch = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

    function onFilterByChange(val) {
      setFilterBy(val);
    }

    function onShow() {
      alert.clear();
      fetchStatistics();
    }

    function onScratchAll() {
      return _onScratchAll.apply(this, arguments);
    }

    function _onScratchAll() {
      _onScratchAll = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                confirmScratch.value = false;
                alert.clear();
                _context.prev = 2;
                _context.next = 5;
                return scratchAll();

              case 5:
                result = _context.sent;
                alert.showSuccess(result.message);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                data = _context.t0.response != null ? _context.t0.response.data : null;
                alert.showError(data != null && data.message != null ? data.message : 'Failed to scratch nominations');

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }));
      return _onScratchAll.apply(this, arguments);
    }

    function tryAutoFetch() {
      if (selectedEventId.value != null && selectedTypeId.value != null && statistics.value == null) {
        fetchStatistics();
      }
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(function () {
      return props.events;
    }, function (events) {
      if (events.length > 0 && selectedEventId.value == null) {
        selectedEventId.value = events[0].id;
        tryAutoFetch();
      }
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(selectedTypeId, function () {
      tryAutoFetch();
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(function () {
      loadFilterStatuses();
    });
    return {
      filterByOptions: FILTER_BY_OPTIONS,
      filterBy: filterBy,
      selectedEventId: selectedEventId,
      selectedTypeId: selectedTypeId,
      statistics: statistics,
      loadingStats: loadingStats,
      scratching: scratching,
      statusOptions: statusOptions,
      alert: alert,
      confirmScratch: confirmScratch,
      onFilterByChange: onFilterByChange,
      onShow: onShow,
      onScratchAll: onScratchAll
    };
  }
}));

/***/ }),

/***/ 1298:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1299);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("670b260d", content, true, {});

/***/ }),

/***/ 1299:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".event-row[data-v-5e984214]{position:relative}.table td[data-v-5e984214]:last-child,.table th[data-v-5e984214]:last-child{width:1px;white-space:nowrap}.event-bg-col[data-v-5e984214]{background:#ffeeba}.event-group td.drag-handle[data-v-5e984214]{border:none;border-top:1px solid #dee2e6}.child-handle[data-v-5e984214]{display:inline-block;vertical-align:middle;margin-right:6px;opacity:.45;-webkit-transform:scale(.8);transform:scale(.8);cursor:-webkit-grab;cursor:grab}.event-group--multi[data-v-5e984214]{border-top:2px solid var(--gray-400);border-bottom:2px solid var(--gray-400)}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/views/Drafts/View/SecretaryDraftView.vue"],"names":[],"mappings":"AA4WA,4BACE,iBAAmB,CACpB,AACD,4EAEE,UAAW,AACX,kBAAoB,CACrB,AACD,+BACE,kBAAoB,CACrB,AAGD,6CACE,YAAa,AACb,4BAA8B,CAC/B,AACD,+BACE,qBAAsB,AACtB,sBAAuB,AACvB,iBAAkB,AAClB,YAAc,AACd,4BAA8B,AACtB,oBAAsB,AAC9B,oBAAqB,AACrB,WAAa,CACd,AACD,qCACE,qCAAsC,AACtC,uCAAyC,CAC1C","file":"SecretaryDraftView.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Hosts the row's own alert, positioned against it (see RowAlert's above-row) */\n.event-row[data-v-5e984214] {\n  position: relative;\n}\n.table th[data-v-5e984214]:last-child,\n.table td[data-v-5e984214]:last-child {\n  width: 1px;\n  white-space: nowrap;\n}\n.event-bg-col[data-v-5e984214] {\n  background: #ffeeba;\n}\n\n/* The handle cell has no bootstrap borders of its own, so keep the row dividers through it */\n.event-group td.drag-handle[data-v-5e984214] {\n  border: none;\n  border-top: 1px solid #dee2e6;\n}\n.child-handle[data-v-5e984214] {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 6px;\n  opacity: 0.45;\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.event-group--multi[data-v-5e984214] {\n  border-top: 2px solid var(--gray-400);\n  border-bottom: 2px solid var(--gray-400);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDraftView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function useDraftView() {
  var draft = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var loadFailed = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function loadDraft(_x) {
    return _loadDraft.apply(this, arguments);
  }

  function _loadDraft() {
    _loadDraft = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(id) {
      var res, data, msg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              loadFailed.value = false;
              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].get(id);

            case 5:
              res = _context.sent;
              draft.value = res.data.data;
              _context.next = 15;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              loadFailed.value = true;
              data = _context.t0.response != null ? _context.t0.response.data : null;
              msg = data != null && data.message != null ? data.message : null;
              if (msg) __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('http-error-persistent', msg);

            case 15:
              _context.prev = 15;
              loading.value = false;
              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9, 15, 18]]);
    }));
    return _loadDraft.apply(this, arguments);
  }

  return {
    draft: draft,
    loading: loading,
    loadFailed: loadFailed,
    loadDraft: loadDraft
  };
}

/***/ }),

/***/ 1301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDraftRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_useFormAlert__ = __webpack_require__(1132);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }




function useDraftRules() {
  var rules = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])({
    first_round_runs_per_person: '',
    total_runs_per_horse: '',
    exclude_first_round: [],
    exclude_total: []
  }); // No-horse-required events never count toward these limits — pinned here so their
  // remove ("x") button is disabled in the UI (see FSearchSelect lockedIds) and, as a
  // backstop against vue-multiselect's backspace-removes-last-tag shortcut, so they
  // snap back if removed anyway. The backend enforces this too regardless of what's
  // submitted (see EloquentEventRepository::updateRuleExclusions).

  var pinnedEventIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var alert = Object(__WEBPACK_IMPORTED_MODULE_2__composables_useFormAlert__["a" /* default */])();

  function withPinned(ids) {
    return _toConsumableArray(new Set([].concat(_toConsumableArray(ids), _toConsumableArray(pinnedEventIds.value))));
  }

  function initRules(draft, events) {
    var s = draft.settings != null ? draft.settings : {};
    rules.first_round_runs_per_person = s.first_round_runs_per_person != null ? s.first_round_runs_per_person : '';
    rules.total_runs_per_horse = s.total_runs_per_horse != null ? s.total_runs_per_horse : '';
    pinnedEventIds.value = events.filter(function (e) {
      return e.requires_horse === false;
    }).map(function (e) {
      return e.id;
    });
    rules.exclude_first_round = withPinned(events.filter(function (e) {
      return e.exclude_first_round_runs_per_person;
    }).map(function (e) {
      return e.id;
    }));
    rules.exclude_total = withPinned(events.filter(function (e) {
      return e.exclude_total_runs_per_horse;
    }).map(function (e) {
      return e.id;
    }));
  }

  function setExcludeFirstRound(ids) {
    rules.exclude_first_round = withPinned(ids);
  }

  function setExcludeTotal(ids) {
    rules.exclude_total = withPinned(ids);
  }

  function saveRules(_x) {
    return _saveRules.apply(this, arguments);
  }

  function _saveRules() {
    _saveRules = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(draftId) {
      var payload, res, data, msg;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              submitting.value = true;
              alert.clear();
              _context.prev = 2;
              payload = {
                first_round_runs_per_person: rules.first_round_runs_per_person !== '' ? rules.first_round_runs_per_person : null,
                total_runs_per_horse: rules.total_runs_per_horse !== '' ? rules.total_runs_per_horse : null,
                exclude_first_round_runs_per_person: rules.exclude_first_round,
                exclude_total_runs_per_horse: rules.exclude_total
              };
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_drafts__["a" /* default */].updateRules(draftId, payload);

            case 6:
              res = _context.sent;
              alert.showSuccess(res.data != null && res.data.message != null ? res.data.message : 'Draft rules have been saved.');
              _context.next = 15;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              data = _context.t0.response != null ? _context.t0.response.data : null;
              msg = data != null && data.message != null ? data.message : 'A server error occurred. Please try again later.';
              alert.showError(msg);

            case 15:
              _context.prev = 15;
              submitting.value = false;
              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10, 15, 18]]);
    }));
    return _saveRules.apply(this, arguments);
  }

  return {
    rules: rules,
    submitting: submitting,
    alert: alert,
    pinnedEventIds: pinnedEventIds,
    initRules: initRules,
    saveRules: saveRules,
    setExcludeFirstRound: setExcludeFirstRound,
    setExcludeTotal: setExcludeTotal
  };
}

/***/ }),

/***/ 1302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftFilterNominations_vue__ = __webpack_require__(1233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_642826b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftFilterNominations_vue__ = __webpack_require__(1304);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DraftFilterNominations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_642826b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DraftFilterNominations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFilterNominations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__ = __webpack_require__(437);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function useFilterNominations() {
  var filterStatuses = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({
    horse: [],
    rider: []
  });
  var filterBy = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('horse');
  var selectedEventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var selectedTypeId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var statistics = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
  var loadingStats = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var scratching = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var statusOptions = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    var list = filterStatuses.value[filterBy.value] || [];
    return list.map(function (s) {
      return {
        id: s.id,
        name: s.name
      };
    });
  });

  function loadFilterStatuses() {
    return _loadFilterStatuses.apply(this, arguments);
  }

  function _loadFilterStatuses() {
    _loadFilterStatuses = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, defaults;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].getFilterStatuses();

            case 3:
              res = _context.sent;
              filterStatuses.value = res.data.data;
              defaults = filterStatuses.value[filterBy.value];

              if (defaults.length > 0 && selectedTypeId.value == null) {
                selectedTypeId.value = defaults[0].id;
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              filterStatuses.value = {
                horse: [],
                rider: []
              };

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));
    return _loadFilterStatuses.apply(this, arguments);
  }

  function setFilterBy(val) {
    filterBy.value = val;
    var list = filterStatuses.value[val] || [];
    selectedTypeId.value = list.length > 0 ? list[0].id : null;
    statistics.value = null;
  }

  function fetchStatistics() {
    return _fetchStatistics.apply(this, arguments);
  }

  function _fetchStatistics() {
    _fetchStatistics = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(selectedEventId.value == null || selectedTypeId.value == null)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              loadingStats.value = true;
              _context2.prev = 3;
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].getStatisticsByEvent(selectedEventId.value, {
                filter_by: filterBy.value,
                type_id: selectedTypeId.value
              });

            case 6:
              res = _context2.sent;
              statistics.value = res.data.data;
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](3);
              statistics.value = null;

            case 13:
              _context2.prev = 13;
              loadingStats.value = false;
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 10, 13, 16]]);
    }));
    return _fetchStatistics.apply(this, arguments);
  }

  function scratchAll() {
    return _scratchAll.apply(this, arguments);
  }

  function _scratchAll() {
    _scratchAll = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      var res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(selectedEventId.value == null || selectedTypeId.value == null)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", null);

            case 2:
              scratching.value = true;
              _context3.prev = 3;
              _context3.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_nominations__["a" /* default */].scratchByStatus(selectedEventId.value, {
                filter_by: filterBy.value,
                type_id: selectedTypeId.value
              });

            case 6:
              res = _context3.sent;
              statistics.value = null;
              return _context3.abrupt("return", res.data);

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](3);
              throw _context3.t0;

            case 14:
              _context3.prev = 14;
              scratching.value = false;
              return _context3.finish(14);

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 11, 14, 17]]);
    }));
    return _scratchAll.apply(this, arguments);
  }

  return {
    filterBy: filterBy,
    selectedEventId: selectedEventId,
    selectedTypeId: selectedTypeId,
    statistics: statistics,
    loadingStats: loadingStats,
    scratching: scratching,
    statusOptions: statusOptions,
    loadFilterStatuses: loadFilterStatuses,
    setFilterBy: setFilterBy,
    fetchStatistics: fetchStatistics,
    scratchAll: scratchAll
  };
}

/***/ }),

/***/ 1304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"h3 mt-4 mb-3"},[_vm._v("Filter Nominations out of Events")]),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('f-radio-group',{attrs:{"name":"filterBy","label":"Filter by","value":_vm.filterBy,"options":_vm.filterByOptions,"inline":""},on:{"input":_vm.onFilterByChange}}),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 form-group pl-0"},[_c('f-search-select',{attrs:{"id":"filter_event","label":"Select event","value":_vm.selectedEventId,"options":_vm.events,"searchable":false},on:{"input":function($event){_vm.selectedEventId = Number($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-xl-6 form-group pl-0"},[_c('f-search-select',{attrs:{"id":"filter_status","label":_vm.filterBy === 'horse' ? 'Select horse status' : 'Select rider status',"value":_vm.selectedTypeId,"options":_vm.statusOptions,"searchable":false},on:{"input":function($event){_vm.selectedTypeId = Number($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"my-3"},[_c('app-button',{staticClass:"px-xl-5",attrs:{"variant":"primary","block":false,"loading":_vm.loadingStats,"disabled":_vm.selectedEventId == null || _vm.selectedTypeId == null},on:{"click":_vm.onShow}},[_vm._v("Show")])],1),_vm._v(" "),_c('form-alert',{staticClass:"mt-2",attrs:{"message":_vm.alert.message.value,"type":_vm.alert.type.value}}),_vm._v(" "),(_vm.statistics != null)?[_c('div',{staticClass:"mt-2 d-flex"},[_vm._v("\n        Total: "),_c('strong',{staticClass:"pl-1"},[_vm._v(_vm._s(_vm.statistics.total))]),_vm._v(".\n        "+_vm._s(_vm.filterBy === 'horse' ? 'Horses' : 'Riders')+": "),_c('strong',{staticClass:"pl-1"},[_vm._v(_vm._s(_vm.statistics.grouped))]),_vm._v(".\n      ")]),_vm._v(" "),_c('div',{staticClass:"my-3"},[_c('app-button',{staticClass:"px-xl-5",attrs:{"variant":"primary","block":false,"loading":_vm.scratching,"disabled":_vm.statistics.total === 0},on:{"click":function($event){_vm.confirmScratch = true}}},[_vm._v("Scratch all")])],1)]:_vm._e()],2),_vm._v(" "),(_vm.confirmScratch)?_c('confirm-modal',{attrs:{"message":"Are you sure you want to scratch all filtered nominations? This cannot be undone.","loading":_vm.scratching},on:{"confirm":_vm.onScratchAll,"cancel":function($event){_vm.confirmScratch = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"bg-white rounded mb-4 p-3"},[_c('page-heading',[_vm._v(_vm._s(_vm.draft ? _vm.draft.name : 'Draft'))]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-center py-5"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])]):(!_vm.loadFailed && _vm.draft)?[_c('div',{staticClass:"mb-5 pt-3 p-2 p-sm-3 bg-lighter border-top",staticStyle:{"font-size":"1.1rem"}},[_c('div',{staticClass:"mb-2"},[_c('strong',[_vm._v("Start Date:")]),_vm._v(" "+_vm._s(_vm.formatDate(_vm.draft.start_date)))]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('strong',[_vm._v("Finish Date:")]),_vm._v(" "+_vm._s(_vm.formatDate(_vm.draft.end_date)))]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('strong',[_vm._v("Status:")]),_vm._v(" "+_vm._s(_vm.draft.state.name))]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Event members:")]),_vm._v(" "+_vm._s(_vm.draft.settings.event_members_allowed ? 'Allowed' : 'Not Allowed'))])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-start mb-3"},[_c('h2',{staticClass:"h3 mb-3"},[_vm._v("Draft Events")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-primary px-xl-5 mt-0",attrs:{"to":{ name: 'Event Create', params: { id: _vm.draftId } }}},[_vm._v("Add New Event")])],1),_vm._v(" "),_c('div',{staticClass:"mb-5 position-relative"},[(_vm.eventsLoading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),_c('draggable',{staticClass:"table table-hover table-striped table-bordered",attrs:{"tag":"table","handle":".drag-handle","list":_vm.eventGroups,"move":_vm.onMoveGroup},on:{"end":_vm.onDragEnd}},[_vm._l((_vm.eventGroups),function(group){return _c('draggable',{key:group.id,staticClass:"event-group",class:{ 'event-group--multi': group.rows.length > 1 },attrs:{"tag":"tbody","list":group.rows,"group":("unit-" + (group.id)),"handle":".child-handle","move":_vm.onMoveWithinUnit},on:{"end":_vm.onDragEnd}},[_vm._l((group.rows),function(event){return _c('tr',{key:event.id,staticClass:"event-row",attrs:{"data-row-id":event.id}},[_c('td',{staticClass:"icon-btn icon-btn--drag drag-handle",staticStyle:{"vertical-align":"middle","margin":"0 auto","display":"table-cell"},attrs:{"title":"Drag to move the whole group"}}),_vm._v(" "),_c('td',[(_vm.rowAlert.message && _vm.rowAlert.rowId === event.id)?_c('row-alert',{attrs:{"above-row":"","message":_vm.rowAlert.message,"type":_vm.rowAlert.type,"alert-key":_vm.rowAlert.id},on:{"dismiss":_vm.clearRowAlert}}):_vm._e(),_vm._v(" "),(_vm.hasSiblings(event, group))?_c('span',{staticClass:"icon-btn icon-btn--drag child-handle",attrs:{"title":"Drag to reorder within the group"}}):_vm._e(),_vm._v("\n                  "+_vm._s(event.name)+"\n                  "),_c('div',{staticClass:"d-md-none"},[_c('strong',[_vm._v("Cost:")]),_vm._v(" $"+_vm._s(event.cost))]),_vm._v(" "),_c('div',{staticClass:"d-md-none"},[_c('strong',[_vm._v("Declared Prize Money:")]),_vm._v(" "+_vm._s(event.declared_prize != null ? ("$" + (event.declared_prize)) : ''))]),_vm._v(" "),_c('div',{staticClass:"d-md-none"},[_c('strong',[_vm._v("Type:")]),_vm._v(" "+_vm._s(event.type.name))]),_vm._v(" "),_c('div',{staticClass:"d-md-none"},[_c('strong',[_vm._v("Final Noms:")]),_vm._v(" "+_vm._s(event.final_noms))]),_vm._v(" "),_c('div',{staticClass:"d-md-none"},[_c('strong',[_vm._v("Total Noms:")]),_vm._v(" "+_vm._s(event.total_noms))]),_vm._v(" "),_c('div',{staticClass:"d-md-none"},[_c('strong',[_vm._v("Rounds:")]),_vm._v(" "+_vm._s(event.rounds))]),_vm._v(" "),_c('div',{staticClass:"d-md-none"},[_c('strong',[_vm._v("Max Horses / Submissions:")]),_vm._v(" "+_vm._s(_vm.maxHorsesOrSubmissions(event)))])],1),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v("$"+_vm._s(event.cost))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(event.declared_prize != null ? ("$" + (event.declared_prize)) : ''))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(event.type.name))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(event.final_noms))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell"},[_vm._v(_vm._s(event.total_noms))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell event-bg-col"},[_vm._v(_vm._s(event.rounds))]),_vm._v(" "),_c('td',{staticClass:"d-none d-md-table-cell event-bg-col"},[_vm._v(_vm._s(_vm.maxHorsesOrSubmissions(event)))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"actions__wrap"},[_c('router-link',{staticClass:"icon-btn icon-btn--edit",attrs:{"to":{ name: 'Event Edit', params: { id: _vm.draftId, eventId: event.parent_id != null ? event.parent_id : event.id } },"title":"Edit"}}),_vm._v(" "),_c('button',{staticClass:"btn-actions btn-delete",attrs:{"title":"Delete","disabled":_vm.deleting},on:{"click":function($event){return _vm.confirmDelete(event)}}})],1)])])}),_vm._v(" "),_vm._l((_vm.stripeOffset(group)),function(n){return _c('tr',{key:("stripe-" + n),staticStyle:{"display":"none"},attrs:{"slot":"header"},slot:"header"})})],2)}),_vm._v(" "),_c('thead',{attrs:{"slot":"header"},slot:"header"},[_c('tr',[_c('th',{staticStyle:{"width":"32px","border":"none"}}),_vm._v(" "),_c('th',[_vm._v("Event Name")]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v("Cost")]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v("Declared Prize Money")]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v("Final Noms")]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell"},[_vm._v("Total Noms")]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell event-bg-col"},[_vm._v("Rounds")]),_vm._v(" "),_c('th',{staticClass:"d-none d-md-table-cell event-bg-col"},[_vm._v("Max Horses / Submissions")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])]),_vm._v(" "),(!_vm.eventGroups.length && !_vm.eventsLoading)?_c('tbody',{attrs:{"slot":"footer"},slot:"footer"},[_c('tr',[_c('td',{staticClass:"text-center text-muted py-3",attrs:{"colspan":"10"}},[_vm._v("No events found.")])])]):_vm._e()],2)],1),_vm._v(" "),_c('h2',{staticClass:"h3 mb-3"},[_vm._v("Draft Rules")]),_vm._v(" "),_c('form',{staticClass:"mb-4",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSaveRules($event)}}},[_c('form-alert',{attrs:{"message":_vm.rulesAlert.message.value,"type":_vm.rulesAlert.type.value}}),_vm._v(" "),_c('div',{staticClass:"form-group mb-2 d-flex align-items-center"},[_c('label',{staticClass:"committee__form-label mb-0 mr-3",staticStyle:{"width":"230px","flex-shrink":"0"}},[_vm._v("First Round Runs Per Person")]),_vm._v(" "),_c('f-text',{staticClass:"mr-2",staticStyle:{"width":"80px","flex-shrink":"0"},attrs:{"id":"first_round_runs_per_person","type":"number","value":_vm.rules.first_round_runs_per_person},on:{"input":function($event){_vm.rules.first_round_runs_per_person = $event}}}),_vm._v(" "),_c('div',{staticStyle:{"min-width":"190px","max-width":"480px","flex":"1"}},[_c('f-search-select',{attrs:{"id":"exclude_first_round","value":_vm.rules.exclude_first_round,"options":_vm.events,"multiple":true,"locked-ids":_vm.pinnedEventIds,"placeholder":"Exclude events..."},on:{"input":_vm.setExcludeFirstRound}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group mb-2 d-flex align-items-center"},[_c('label',{staticClass:"committee__form-label mb-0 mr-3",staticStyle:{"width":"230px","flex-shrink":"0"}},[_vm._v("Total Runs Per Horse")]),_vm._v(" "),_c('f-text',{staticClass:"mr-2",staticStyle:{"width":"80px","flex-shrink":"0"},attrs:{"id":"total_runs_per_horse","type":"number","value":_vm.rules.total_runs_per_horse},on:{"input":function($event){_vm.rules.total_runs_per_horse = $event}}}),_vm._v(" "),_c('div',{staticStyle:{"min-width":"190px","max-width":"480px","flex":"1"}},[_c('f-search-select',{attrs:{"id":"exclude_total_runs","value":_vm.rules.exclude_total,"options":_vm.events,"multiple":true,"locked-ids":_vm.pinnedEventIds,"placeholder":"Exclude events..."},on:{"input":_vm.setExcludeTotal}})],1)],1),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('button',{staticClass:"btn btn-primary px-xl-5",attrs:{"type":"submit","disabled":_vm.submittingRules}},[_vm._v("Save Rules")])])],1),_vm._v(" "),_c('draft-filter-nominations',{attrs:{"events":_vm.events}})]:_vm._e(),_vm._v(" "),(_vm.eventToDelete)?_c('confirm-modal',{attrs:{"message":("You are about to delete event " + (_vm.eventToDelete.name) + ". Are you sure?"),"loading":_vm.deleting},on:{"confirm":_vm.handleDelete,"cancel":function($event){_vm.eventToDelete = null}}}):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.6c761bc99796028687fa.js